import { Link } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";
import { CONTACT, POLICIES, SOCIALS } from "../data/content";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-navy text-primary-foreground">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
      <div className="grid md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <p className="font-serif text-3xl md:text-4xl leading-tight">
            Victoria Career College
          </p>
          <p className="mt-1 text-xs tracking-[0.25em] uppercase text-gold">
            of Health &amp; Business Ltd.
          </p>
          <p className="mt-6 text-sm text-primary-foreground/60 leading-relaxed max-w-sm">
            A private post-secondary college in Surrey, British Columbia.
            Adventures in learning — expertise in life.
          </p>
          <div className="mt-6 flex gap-3" data-testid="footer-socials">
            {SOCIALS.map((s) => (
              <a
                key={s.name}
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.name}
                data-testid={`footer-social-${s.name.toLowerCase()}`}
                className="w-10 h-10 inline-flex items-center justify-center rounded-full border border-primary-foreground/20 text-primary-foreground/70 transition-all duration-300 hover:border-gold hover:text-gold hover:-translate-y-0.5"
              >
                {s.name === "Instagram" ? <Instagram size={17} /> : <Facebook size={17} />}
              </a>
            ))}
          </div>
        </div>
        <div className="md:col-span-2">
          <p className="text-xs tracking-[0.25em] uppercase text-gold mb-5">Explore</p>
          <ul className="space-y-3 text-sm">
            {[
              ["Programs", "/programs"],
              ["About the College", "/about"],
              ["News & Stories", "/news"],
              ["Admissions & Contact", "/contact"],
            ].map(([label, to]) => (
              <li key={to}>
                <Link
                  to={to}
                  data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className="text-primary-foreground/70 hover:text-gold transition-colors duration-300"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="text-xs tracking-[0.25em] uppercase text-gold mb-5">College Policies</p>
          <ul className="space-y-3 text-sm" data-testid="footer-policies">
            {POLICIES.map((p) => (
              <li key={p.file}>
                <a
                  href={p.file}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-policy-${p.file.split("/").pop().replace(".pdf", "")}`}
                  className="text-primary-foreground/70 hover:text-gold transition-colors duration-300"
                >
                  {p.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="text-xs tracking-[0.25em] uppercase text-gold mb-5">Contact</p>
          <ul className="space-y-3 text-sm text-primary-foreground/70">
            <li data-testid="footer-address">{CONTACT.address}</li>
            <li data-testid="footer-phone">{CONTACT.phone}</li>
            <li data-testid="footer-email">{CONTACT.email}</li>
          </ul>
        </div>
      </div>
      <div className="mt-16 pt-8 border-t border-primary-foreground/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-primary-foreground/40">
        <p>© {new Date().getFullYear()} Victoria Career College of Health and Business Ltd. All rights reserved.</p>
        <p>Certified by the Private Training Institutions Regulatory Unit (PTIRU), Government of British Columbia.</p>
      </div>
    </div>
  </footer>
);
